// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
/** @deprecated
 * To be removed as part of ED-25129 in favour of ToolbarWidthsFullPageNext along with references
 * to platform_editor_toolbar_responsive_fixes feature gate
 */
export enum ToolbarWidthsFullPage {
	XXL = 650,
	XL = 580,
	L = 540,
	M = 490,
	S = 410,
}
